export const VIEW = 'View';
export const ASC = 'asc';
export const DESC = 'desc';
export const DEFAULT_MILE = 50;